import React from "react";
import PropTypes from "prop-types";

import "./SurvivalProbability.scss";

function SurvivalProbability({ value, label = "" }) {
  return (
    <div className="SurvivalProbability">
      <h5 className="text-center" style={{ marginTop: "0.25em", marginBottom: "-0.1em" }}>
        {Math.round(value * 100)}%
      </h5>
      <p className="text-center text-muted">{label}</p>
    </div>
  );
}

SurvivalProbability.propTypes = {
  value: PropTypes.number.isRequired,
  label: PropTypes.string,
};

export default SurvivalProbability;
